import { render, staticRenderFns } from "./PasswordRecoverSmsPin.vue?vue&type=template&id=23774fae"
import script from "./PasswordRecoverSmsPin.vue?vue&type=script&lang=js"
export * from "./PasswordRecoverSmsPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports